import globalStateManager from "./globalState.js";
import hiveStateManager from "./hiveState.js";
import inventoryStateManager from "./inventoryState.js";
import playerStateManager from "./playerState.js";

export const gameState = globalStateManager().getInstance();
export const hiveState = hiveStateManager().getInstance();
export const inventoryState = inventoryStateManager().getInstance();
export const playerState = playerStateManager().getInstance();
